// src/voice.js

let voiceEnabled = false;

export function enableVoice() {
  voiceEnabled = true;
}

export function disableVoice() {
  voiceEnabled = false;
  stopSpeak();
}

export function isVoiceEnabled() {
  return voiceEnabled;
}

export function stopSpeak() {
  if ("speechSynthesis" in window) {
    window.speechSynthesis.cancel();
  }
}

export function speak(text) {
  if (!voiceEnabled) return;
  if (!text) return;
  if (!("speechSynthesis" in window)) return;

  window.speechSynthesis.cancel();

  const utterance = new SpeechSynthesisUtterance(text);

  utterance.lang = "hu-HU";
  utterance.rate = 0.95;
  utterance.pitch = 1;
  utterance.volume = 1;

  const voices = window.speechSynthesis.getVoices();

  const hungarianVoice =
    voices.find(v => v.lang === "hu-HU") ||
    voices.find(v => v.lang?.startsWith("hu"));

  if (hungarianVoice) {
    utterance.voice = hungarianVoice;
  }

  window.speechSynthesis.speak(utterance);
}
